<app-card *ngIf="publication"
  class="mt-2">
  <!-- Header -->
  <div
    class="grid grid-flow-col grid-cols-[80px_1fr_80px] print:flex print:justify-between border-b border-b-gray-300 shadow print:border-0 print:shadow-none">
    <!-- Company logo -->
    <div class="">
      <!-- ADP -->
      <app-logo-card *ngIf="publication.publisher === 'ADP Global Product & Development Connect'"
        src="assets/logo-adp.webp"
        alt="ADP logo"></app-logo-card>
      <!-- ADP -->
      <app-logo-card *ngIf="publication.publisher === 'ADP Tech & Innovation Blog'"
        src="assets/logo-adp.webp"
        alt="ADP logo"></app-logo-card>
    </div>
    <!-- Position -->
    <div class="flex place-content-center flex-col text-center print:flex-grow print:text-left print:pl-4">
      <h3 class="text-xl print:text-lg print:-mt-1">
        {{publication.name}}
        <span class="block text-sm print:text-xs">
          {{publication.publisher}}
        </span>
      </h3>
    </div>
    <!-- Period -->
    <div
      class="flex place-content-center flex-col text-sm pr-4 print:whitespace-nowrap print:flex-row print:pr-0 print:items-center">
      {{ publication.releaseDate | date: 'MMM/yyyy'}}
    </div>
  </div>

  <!-- Summary -->
  <div class="p-4 pt-0 print:p-0 leading-relaxed text-base print:text-xs">
    <p class="pt-4">
      {{publication.summary}}
    </p>
  </div>
</app-card>